// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edsc-timeline-data-section{position:relative;display:flex;flex-direction:column;justify-content:flex-end;height:100%;padding-bottom:1.575rem;pointer-events:none}.edsc-timeline-data-section__entry{position:relative;height:1.5rem;width:100%}.edsc-timeline-data-section__interval{position:absolute;top:.25rem;background-color:#25c85b;height:1rem;min-width:2px;border-radius:.125rem}", ""]);
// Exports
module.exports = exports;
